import { ClusteringResult, NeighborhoodClustersJob } from 'interfaces/job';
import { compact, filter, first, map, range, size } from 'lodash';

import { formatNumber, toPercentage } from 'utils/helpers';

export interface CellNeighborhoodJobSummary {
  approvedClusteringRuns: number;
  clusteringRuns: number;
  slides: number;
}

export const getCellNeighborhoodColumnLabels = (
  clusteringResult: Pick<
    ClusteringResult,
    'cellFractionsPerCluster' | 'clusteringCellLabelsOrder' | 'clusteringCentroids'
  >
) => {
  const configuredLabels = compact(clusteringResult.clusteringCellLabelsOrder);
  const inferredColumnCount =
    size(first(clusteringResult.cellFractionsPerCluster)) || size(first(clusteringResult.clusteringCentroids));

  if (inferredColumnCount > 0 && size(configuredLabels) === inferredColumnCount) {
    return configuredLabels;
  }

  return map(range(inferredColumnCount), (columnIndex) => `Feature ${columnIndex + 1}`);
};

export const summarizeCellNeighborhoodJob = (
  job?: Pick<NeighborhoodClustersJob, 'manifest' | 'results'>
): CellNeighborhoodJobSummary => {
  const clusteringRuns = size(job?.results?.kMeansClusteringResults);
  const approvedClusteringRuns = size(filter(job?.results?.kMeansClusteringResults, 'internallyApproved'));

  return {
    approvedClusteringRuns,
    clusteringRuns,
    slides: size(job?.manifest),
  };
};

export const formatCellNeighborhoodMatrixValue = (value: number, valueMode: 'fraction' | 'number') => {
  return valueMode === 'fraction' ? toPercentage(value, 1) : formatNumber(value);
};
